import { Box, SxProps } from '@mui/material';

export const StatusDot = ({ sx, color }: { sx?: SxProps; color?: string }) => (
  <Box
    sx={{
      width: 8,
      minWidth: 8,
      height: 8,
      borderRadius: '50%',
      backgroundColor: color || 'grey.300',
      display: 'inline-block',
      ...sx,
    }}
  />
);
